import { useEffect, useState } from 'react';

// Single shared fetch of the merchant catalog for the landing's product rows.
// Module-cached so New Arrivals / Best Sellers / On Sale share ONE network call.
//
// NOTE: env is read LAZILY inside the function (not at module top-level) and
// guarded. Vite only inlines `import.meta.env` where it recognises the access;
// a top-level `const x = import.meta.env.FOO` was left raw and threw
// "import.meta.env is undefined" at import time, blanking the whole app.
let _cache = null; // Promise<product[]>

export function fetchStorefrontProducts() {
  if (_cache) return _cache;

  let API_BASE = 'https://dashboard.offloadhost.com';
  let CUSTOMER_ID = '';
  try {
    const env = import.meta.env || {};
    API_BASE = env.VITE_STOREFRONT_API_URL || API_BASE;
    CUSTOMER_ID = env.VITE_CUSTOMER_ID || '';
  } catch (_) { /* env unavailable — fall back, never crash */ }

  if (!CUSTOMER_ID) { _cache = Promise.resolve([]); return _cache; }
  _cache = fetch(`${API_BASE}/storefront/${CUSTOMER_ID}/products`)
    .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
    .then((d) => d?.products || [])
    .catch((err) => { if (err?.name !== 'AbortError') console.error('storefront products fetch failed:', err); return []; });
  return _cache;
}

export function useStorefrontProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let on = true;
    fetchStorefrontProducts().then((p) => { if (on) { setProducts(p); setLoading(false); } });
    return () => { on = false; };
  }, []);
  return { products, loading };
}
